import request from '@/api/request'

export default {
  async getColors () {
    return (await request.get(`module/action/marketplace/comfortflex/color`)).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/comfortflex/size`)).data
  },
  async getCategories () {
    return (await request.get(`module/action/marketplace/comfortflex/category/retrieve`)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/comfortflex/brand/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/comfortflex/index.js